import React, { memo } from 'react';
import { Provider } from 'react-redux'

import logo from './logo.svg';
import Navmenu from './components/Navbar'
import SingleChatDownloader from './pages/SingleChatDownloader'
import Homepage from './pages/Homepage'
import Search from './pages/Search'
import Chats from './pages/Chats'
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { styled, useTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import Box from '@mui/material/Box';

import Main from './components/Main';


import { useSelector } from 'react-redux';


import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom'

import Card from 'react-bootstrap/Card';

import './App.css';
import Video from './pages/Video';
import NotFound from './components/NotFound';
import NotFoundPage from './pages/Chats';



const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));


function App() {
  const open = useSelector((state) => state.open.value)
  const drawerWidth = 240;


  return (
    <ThemeProvider theme={darkTheme}>
      <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
      <Router>
      <CssBaseline />

        <Navmenu />
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route exact path="chatdownloader" element={<SingleChatDownloader />} />
            <Route path={"/search"} element={<Search />} />
            <Route path={"/chats"} element={<Chats />} />
            <Route path={"/video/:id"} element={<Video />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
      </Router>
    </ThemeProvider>

  );
}

export default memo(App);


